import React from "react";
import "../General/General.css";
import CVTemplate from "./CVTemplate";

export default function MyCV() {

        return <CVTemplate jobId={0}/>


}